interface StepHeadingProps {
  /** Heading text displayed as the step title. */
  title: string;
  /** id for the h1 element — used with aria-labelledby on the parent form. */
  id: string;
}

/**
 * @component StepHeading
 * @description Reusable heading block for multi-step forms. Renders the step title
 * as an h1. Designed to pair with a parent form's aria-labelledby.
 * @param title - The step title text.
 * @param id - id applied to the h1 for aria-labelledby on the parent form.
 * @returns The h1 heading element.
 */
export default function StepHeading({ title, id }: StepHeadingProps) {
  return (
    <h1 id={id} className="text-display text-near-black text-center">
      {title}
    </h1>
  );
}
